import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-02549f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mark" }
const _hoisted_2 = { class: "msg-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "提示", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "button-list" }


    import {useRouter} from 'vue-router'
    
export default /*#__PURE__*/_defineComponent({
  __name: 'MsgBox',
  props: ['score', 'msgText'],
  emits: ['callback'],
  setup(__props, { emit: __emit }) {

    const router = useRouter();
    const props = __props
    const emit = __emit
    
    const goHome = () => {
        emit('callback')
    }


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["icon pass-icon", { 'pass-icon': __props.score >= 80 , 'fail-icon': __props.score <= 80 }])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass({ 'success': __props.score >= 80 , 'fail': __props.score <= 80 })
        }, _toDisplayString(__props.msgText), 3)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          onClick: goHome,
          size: "large",
          type: "warning"
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回页面")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})